import { Globe, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useUx } from "@/lib/UxProvider";
import { LANGUAGES, LANG_BY_CODE } from "@/constants/languages";

/** Global language switcher — usable on every page (workspace top bar + public pages). */
export function LanguageSwitcher({ variant = "ghost" }) {
  const { prefs, update } = useUx();
  const current = LANG_BY_CODE[prefs.language] || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`flex items-center gap-1.5 rounded-md px-2 py-1.5 text-sm font-medium transition-colors
            ${variant === "outline" ? "border border-border bg-background hover:bg-accent" : "hover:bg-accent"}`}
          aria-label="Select language"
        >
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{current.native}</span>
          <span className="sm:hidden uppercase text-xs">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 max-h-[70vh] overflow-auto">
        <DropdownMenuLabel className="text-xs">Language · भाषा</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => { localStorage.setItem("reason_lang_explicit", "1"); update({ language: l.code }); }}
            className="flex items-center justify-between"
          >
            <span>{l.native} <span className="text-muted-foreground text-xs">· {l.label}</span></span>
            {prefs.language === l.code && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
